class SearchInputSync {
  constructor() {
    this.msbSearchInputs = document.querySelectorAll(".msb__search-input");
    this.navbarSearchModal = document.querySelector(
      "details-modal.header__search",
    );

    if (this.msbSearchInputs.length > 0 && this.navbarSearchModal) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.msbSearchInputs.forEach((input) => {
      // On click, open the main navigation search
      input.addEventListener("click", (event) => {
        event.preventDefault();
        this.openNavbarSearch();
      });
    });
  }

  openNavbarSearch() {
    const details = this.navbarSearchModal.querySelector("details");
    if (details) {
      details.setAttribute("open", "");

      // Focus the search input in the modal
      const navbarSearchInput = this.navbarSearchModal.querySelector(
        'input[type="search"]',
      );
      if (navbarSearchInput) {
        setTimeout(() => {
          navbarSearchInput.focus();
        }, 10); // Small delay to ensure modal is open
      }
    }
  }
}

// Initialize the functionality once the DOM is loaded
window.addEventListener("DOMContentLoaded", () => {
  new SearchInputSync();
});
